"use strict";

exports.__esModule = true;
exports.CrosSellClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _constants = require("../constants");
const CrosSellClient = {
  fetchAsync({
    data
  }) {
    const requestId = 'HOTEL_CROSS_SELL_ASYNC';
    return _http.$http.post(requestId, _constants.ENDPOINTS.HOTEL_CROSS_SELL_ASYNC, {
      data
    }).then(({
      data
    }) => data);
  },
  fetchPoll({
    csId,
    sId
  }) {
    const requestId = 'HOTEL_CROSS_SELL_POLL';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.HOTEL_CROSS_SELL_POLL, {
      csId,
      sId
    });
    return _http.$http.get(requestId, endPoint).then(({
      data
    }) => data);
  }
};
exports.CrosSellClient = CrosSellClient;